export const MUTATION_TYPES = {
  RESET: 'reset',
  SET_ACADEMIC_YEARS: 'setAcademicYears',
  SET_MONTHS: 'setMonths',
  SET_CENTERS: 'setCenters',
  SET_SERVICES: 'setServices',
  SET_SPECIALIST: 'setSpecialsts',
  SET_STUDENT: 'setStudent',
  SET_CERTIFICATION_SUMMARY: 'setCertificationSummary',
  SET_CLEAR_CATALOG: 'setClearCatalog',
  SET_UPLOADED_STATUS: 'setUploadedStatus',
  SET_PAGING: 'setPaging',
  SET_DOCUMENT_TYPES: 'setDocumentType',
  SET_THERAPY_DOCUMENTS_TYPES: 'settherapyDocumentTypes',
  SET_PROVIDERS: 'SET_PROVIDERS',
  SET_SPECIALIST_OR_COMPANY: 'setSpecialistOrComapany',
};

export const ACTION_TYPES = {
  RESET: 'reset',
  GET_ACADEMIC_YEARS: 'getAcademicYears',
  GET_MONTHS: 'getMonths',
  GET_CENTERS: 'getCenters',
  GET_SERVICES: 'getServices',
  GET_SPECIALIST: 'getSpecialist',
  GET_STUDENT: 'getStudent',
  UPLOAD_FILES: 'uploadFiles',
  GET_DOCUMENT_TYPES: 'getDocumentTypes',
  GET_THERAPY_DOCUMENTS_TYPES: 'gettherapyDocumentTypes',
  GET_SPECIALIST_OR_COMPANY: 'getSpecialistOrComapany',
  GET_SPECIALIST_OR_COMPANY_CENTERS: 'getSpecialistOrComapanyCenter',
};
